import { ConfirmInfo, Icon } from '@coop/components';
import { CircleInfoIcon } from '@coop/icons';
import classNames from 'classnames';

import useModal from '../../../common/hooks/useModal';
import styles from './MaxPromotionUsage.module.scss';

const MaxPromotionUsageNotification = (props: { text: string }) => {
    const { isOpen, open, close } = useModal('MaxPromotionUsage');

    return (
        <>
            <button
                type="button"
                className={classNames(styles.Trigger)}
                onClick={open}
                aria-label={`Max ${props.text} per hushåll`}
            >
                <Icon icon={<CircleInfoIcon />} aria-hidden size="small" />
                <span>Max {props.text}/hushåll</span>
            </button>
            <ConfirmInfo
                show={isOpen}
                heading={`Max ${props.text} per hushåll`}
                message="Erbjudandet gäller ett begränsat antal per hushåll. Utöver den angivna mängden gäller ordinarie pris."
                close={close}
            />
        </>
    );
};

export default MaxPromotionUsageNotification;
